<!-- [ngClass]="{ 'white-space': app.view !== 'home' }" -->
<div class="white-space" [innerHtml]="app.field.highlightLinks(displayedText)">
  {{ displayedText }}
</div>
<div class="col-md-12">
  @if (isTooBig) {
    <button class="btn btn-sm isText" (click)="cut()">
      {{ isShortened ? app.text.thread.showLess : app.text.thread.showMore }}
    </button>
  }
</div>
